import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
@Component({
  selector: 'app-menu-producer',
  templateUrl: './menu-producer.component.html',
  styleUrls: ['./menu-producer.component.scss']
})
export class MenuProducerComponent implements OnInit {
  public producerLogged: boolean = false;
  producerName: string = '';
  
  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    if (this.authService.isProducerLoggednIn() == true) {
      this.producerLogged = true
      this.producerName = this.authService.getProducer()['user']['name']
    }
  }

}
